import { render } from "./TheGlobalFooter.vue?vue&type=template&id=6888b5f7&scoped=true&ts=true"
import script from "./TheGlobalFooter.vue?vue&type=script&lang=ts"
export * from "./TheGlobalFooter.vue?vue&type=script&lang=ts"

import "./TheGlobalFooter.vue?vue&type=style&index=0&id=6888b5f7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6888b5f7"]])

export default __exports__